<template>
  <div class="component component--fullscreen" ref="picker" v-if="visable">
    <transition name="overlay">
      <div class="component__overlay" v-if="componentVisible"></div>
    </transition>
    <transition name="containter">
      <div class="component__containter" v-if="componentVisible">
        <div class="wrapper">
          <div class="header" v-if="multiple">{{ $t("picker.selectMultiple") }}</div>
          <div class="header" v-else>{{ $t("picker.select") }}</div>
          <div class="content">
            <div class="options" v-body-scroll-lock="componentVisible">
              <div
                class="option"
                :class="{ 'is-picked': picked.includes(index) }"
                v-for="(option, index) in options"
                :key="index + option.value"
                v-on:click="pickOption(option, index)"
              >
                <div class="option__check">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="32"
                    height="32"
                    class="option__check-svg"
                  >
                    <defs>
                      <path
                        id="a"
                        d="M13.172 20.162l-3.47-3.47a.996.996 0 10-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58a.996.996 0 10-1.41-1.41l-9.88 9.87z"
                      />
                    </defs>
                    <use fill="#282828" xlink:href="#a" />
                  </svg>
                </div>
                <div class="option__label">{{ option.label }}</div>
              </div>
            </div>
          </div>
          <div class="footer">
            <button
              type="button"
              class="picker-btn picker-btn--secondary"
              v-on:click="togglePicker()"
            >{{ $t("common.cancel") }}</button>
            <button
              type="button"
              class="picker-btn picker-btn--primary"
              v-if="(multiple || options.length >= 5) && picked.length > 0"
              v-on:click="commitPicked"
            >{{ $t("common.confirm") }}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Picker',
  props: {
    visable: {
      type: Boolean,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      componentVisible: false,
      picked: [],
    };
  },
  watch: {
    visable(value) {
      this.$nextTick(() => {
        this.componentVisible = value;
      });
    },
  },
  methods: {
    pickOption(option, index) {
      if (option.reset) {
        this.picked = [];
        this.$emit('reset');
        return;
      }

      switch (this.multiple) {
        case false:
          this.picked = [];
          this.picked.push(index);
          if (this.options.length < 5) {
            this.commitPicked();
          }
          break;
        case true:
          this.picked.push(index);
          break;
        default:
      }
    },
    commitPicked() {
      if (!this.multiple) {
        this.$emit('pickOption', this.options[this.picked[0]]);
      } else {
        const options = [];
        this.picked.forEach((optionIndex) => {
          options.push(this.options[optionIndex]);
        });
        this.$emit('pickOption', options);
      }
      this.picked = [];
    },
    togglePicker() {
      this.picked = [];
      this.$emit('togglePicker');
    },
  },
};
</script>

<style lang="sass" scoped>
.component--fullscreen
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  display: flex
  flex-direction: column
  justify-content: flex-end
  z-index: 1040

  transition: all .25s ease

.component__overlay
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040
  opacity: .7

  background-image: linear-gradient(0deg, rgba(44,43,43,0.95) 0%, rgba(33,32,32,0.95) 100%)

.component__containter
  position: relative
  width: 100vw
  overflow: hidden
  z-index: 1050
  margin: 0 auto 0
  padding: 32px 16px

  @media only screen and (min-width : 768px)
    max-width: 475px

.wrapper
  border-radius: 16px

  background-color: #111111

  color: white

.header
  padding: 32px 24px 16px

  font-weight: bold
  font-size: 1rem

.content
  .options
    max-height: 288px
    overflow: auto

    user-select: none

  .option
    display: flex
    align-items: center
    padding: 16px 24px

    cursor: pointer

    &.is-picked
      .option__check-svg
        display: block

      .option__check
        background-color: #ffea00

    &__check
      width: 32px
      height: 32px
      margin-right: 16px

      border-radius: 50%

      background-color: rgba(255, 255, 255, .1)

      transition: background-color .1s cubic-bezier(.4, 0, .2, 1)

    &__check-svg
      display: none

    &__label
      flex-grow: 1

      font-size: 1rem
      font-weight: bold

.footer
  padding: 8px

  text-align: right

  .picker-btn
    padding: 16px
    color: white

    border: none

    background: none

    font-size: 0.875rem
    font-weight: bold

    cursor: pointer
    appearance: none
    outline: none

    &--primary
      color: #ffea00

    &--secondary
      color: #656565

.overlay-enter-active,
.overlay-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1)

.overlay-enter,
.overlay-leave-to
  opacity: 0

.containter-enter-active,
.containter-leave-active
  transition: transform .35s cubic-bezier(0.19, 1, 0.22, 1) .15s

.containter-enter,
.containter-leave-to
  transform: translateY(calc(100% + 32px))
</style>
